import React, { useRef } from 'react'
import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import Earth from '../../assets/images/3d-rendering-planet-earth-removebg-preview.png'
import emailjs from '@emailjs/browser'
import './index.scss'



function Contact() {

const form = useRef()
    const [letterClass, setLetterClass] = useState('text-animate')
    const [imageS, setImage] = useState('text-animate-now')

  
    useEffect(() => {
        const timer = setTimeout(() => {
          setLetterClass('text-animate-hover');
          
        }, 3000);
        
        return () => clearTimeout(timer);
      }, []);

    
      
 









      const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_mpro3lo', 'template_ln8erva', form.current, 'J84A-d6yZA9GRSQcQ')
          .then((result) => {
              console.log(result.text);
              alert("Ok")
          }, (error) => {
              console.log(error.text);
          });
      };
    

  return (
    <>
    <div className="container-short">



    <div className="container contact-page">



      
      <div className="text-zone">
        <h1>
          <AnimatedLetters
            letterClass={letterClass}
            strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
            idx={15}
          />
        </h1>
        <p>
          I am interested in freelance opportunities - especially on ambitious
          or large projects. However, if you have any other requests or
          questions, don't hesitate to contact me using below form either.
        </p>
        <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input placeholder="Name" type="text" name="name" required />
                </li>
                <li className="half">
                  <input
                    placeholder="Email"
                    type="email"
                    name="email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="SEND" />
                </li>
              </ul>
            </form>
          </div>
          
     
        </div>

   

      <div className="info-map">
          Sami Kamran,
          <br />
         From Pakistan 
          <br />
          Gulshan e Iqbal , 75300 <br />
          Karachi  <br />
          <br />
          <span>kamransamisly@gmail.com</span>
        </div>
   

   </div>
   </div>

 
   
    <Loader type="pacman" />
  </>
  )
}

export default Contact



   